import type { ComponentType, FC } from "react";
import { useLocation, useNavigate, useParams } from "react-router";

export type Navigate = ReturnType<typeof useNavigate>;
export type Params = ReturnType<typeof useParams>;
export type Location = ReturnType<typeof useLocation>;

export interface WithRouterProps {
  navigate: Navigate;
  location: ReturnType<typeof useLocation>;
  url: string;
  params: Record<string, string | undefined>;
}

export const withRouter = <P extends WithRouterProps>(
  WrappedComponent: ComponentType<P>
) => {
  const WithRouterComponent: FC<Omit<P, keyof WithRouterProps>> = (props) => {
    // https://reactrouter.com/api/hooks/useNavigate
    const navigate = useNavigate();
    // https://reactrouter.com/api/hooks/useParams
    const params = useParams();

    const location = useLocation();

    const url = window.location.origin;

    return (
      <WrappedComponent
        {...(props as P)}
        navigate={navigate}
        params={params}
        url={url}
        location={location}
      />
    );
  };

  return WithRouterComponent;
};
